import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createRenameTransformer } from '../common/utils';
import { DBPriceSchema, PriceSchema } from './schemas';

export const PriceCodecConfig: TransformerConfig<typeof PriceSchema, typeof DBPriceSchema> = {
  name: 'Price',
  clientSchema: PriceSchema,
  dbSchema: DBPriceSchema,
  transformers: [
    createRenameTransformer<typeof PriceSchema, typeof DBPriceSchema>('id', 'priceId'),
  ],
};

export const encodePriceToDb = createEncodeToDbFn(PriceCodecConfig);
export const decodePriceFromDb = createDecodeFromDbFn(PriceCodecConfig);
